export default __webpack_public_path__ + "static/media/MainImage8k.3cb266c4.png";